import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { BranchSettlementMethodImportFileHdrContainerModel } from '../../../../../../models/aggregates/branch/branch-settlement-method-import-file-hdr-container.model';
import { ApiVisa } from '../../shared';


// https://api.akaun.com/core2/tnt/dm/erp/branch-settlement-method-import-file-hdrs/backoffice-ep/download-master-data-template

@Injectable({
    providedIn: 'root'
  })
  export class BranchSettlementMethodImportFileHdrService extends BaseApiTemplateService<BranchSettlementMethodImportFileHdrContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-method-import-file-hdrs/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-method-import-file-hdrs/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-method-import-file-hdrs/backoffice-ep';
      this.httpClient = http;
    }

    async downloadCSV(authorization: string, apiVisa: ApiVisa) {
      const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
      const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
      const fileBlob = await this.httpClient
          .get(CSV_URL, { headers, responseType: 'blob' })
          .toPromise();
      return fileBlob;
  }
  }